import messages from '../messages.js';
import { useTrackingManager } from '../TrackingManagerContext.js';
const useMessages = () => {
  const _useTrackingManager = useTrackingManager(),
    region = _useTrackingManager.region;
  if (region === 'EU') return messages.euMessages;
  return messages.defaultMessages;
};
export { useMessages as default };
//# sourceMappingURL=useMessages.js.map
